import React from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";

const Hero = () => (
  <div className="text-center hero my-5">
    <img 
      className="mb-3 app-logo" 
      src="https://uploads.kuzfit.com/KuzFit-Logo.png" 
      alt="KuzFit Logo" 
      width="500" 
      style={{ width: '500px', height: 'auto' }}
    />
    <h1 className="mb-4">Kustom Fitted Products</h1>

    <p className="lead mb-4">
       We are a platform that allows you to create custom fitted products tailored to your style and performance needs
    </p>

    <Link to="/upload/1">
      <Button color="primary" size="lg" className="px-4 py-2">
        Get Started
      </Button>
    </Link>
  </div>
);

export default Hero;
